import { getWithRootPathGetter } from '@/api/utils';

const withRoot = getWithRootPathGetter('/opobff/opo-platform');

export const opobffHospitalApiPaths = {
  hospitals: withRoot('/facilities/hospitals'),
} as const;

export const getOpobffHospitalApiUrl = {
  hospitals: () => opobffHospitalApiPaths.hospitals,
};
